import createStore from "astrid-helpers/src/createStore";
export const [getDocument, setDocument, useDocument, onDocument] = createStore();
//# sourceMappingURL=document.js.map